import { render, staticRenderFns } from "./Contribution.vue?vue&type=template&id=486c489a&scoped=true&"
import script from "./Contribution.vue?vue&type=script&lang=js&"
export * from "./Contribution.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=486c489a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c489a",
  null
  
)

export default component.exports